const myModelsTooltipContent = `This data shows the full lifetime of your models since their publish day and their total
  numbers.
  
  <ul>
    <li>
      Conversion rate reflects the success of the model performance, which is model's total
      sales divided by total views.
    </li>
    <li>
      Revenue is the total amount of money that the particular model has earned (after all
      fees).
    </li>
  </ul>`

export default myModelsTooltipContent
